if( jQuery('body').hasClass('page-template-template-cabinet') ){

    // Open a URL in a lightbox
    //var lightbox = lity('//www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2783.30961812063!2d4.8585407!3d45.764984899999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47f4ea89a8ea43b1%3A0xcf3a9743188d78ea!2sM%C3%A9decine%20esth%C3%A9tique%20-%20Lyon%20%3A%20Cabinet%20Palais%20Flore!5e0!3m2!1sfr!2sfr!4v1669972407854!5m2!1sfr!2sfr');

    // Bind as an event handler
    jQuery(document).on('click', '.gmap-popup a', lity);

}